import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30000, // Consider data stale after 30 seconds
      gcTime: 3600000, // Cache for 1 hour (formerly cacheTime)
      refetchOnWindowFocus: false,
    },
  },
}); 